$(document).ready(function() {
    sliderWithCounter(".comments-slider", "comments-slider");
})

